 /*  Send business club signup form events to Meta and GTM (Form ID: 78460) */
 window.addEventListener('load', function () {
    const formEmbed = document.querySelector('[data-forms-id="forms-root-78460"] shopify-forms-embed#app-embed');
    if (formEmbed && formEmbed.shadowRoot) {
      const formElement = formEmbed.shadowRoot.querySelector('form');
      if (formElement) {
        console.log('B2B FORM ID 78460');
        formElement.addEventListener('submit', function (event) {
          const errors = formElement.querySelectorAll('output[class*="_formError"]');
          const formEmail = formElement.querySelector('input#email');
          const emailValue = formEmail?.value || null;
          console.log('B2B FORM SUBMIT', (errors?.length ? errors?.length + ' ERRORS' : 'SUCCESS'), emailValue);
          /* Form submit successful when there are no field errors */
          if (emailValue && errors?.length === 0) {
            /* Meta Lead event */
            if (typeof fbq === 'function') {
              console.log('B2B FORM META LEAD', emailValue, errors);
              fbq('track', 'Lead', {
                value: 1,
                currency: 'USD',
              });
            }
            /* Custom event sent to GTM */
            if (Shopify && Shopify.analytics) {
              console.log('B2B FORM CUSTOM EVENT: businessClubFormSubmitted', emailValue);
              Shopify.analytics.publish('custom:businessClubFormSubmitted', {
                event: 'businessClubFormSubmitted',
                formData: { email: emailValue }
              });
            }
          }
        });
      }
    }
  });